<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-star`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.583 44.123a1.667 1.667 0 01-2.38-1.675L11.417 30.8A1.667 1.667 0 0011 29.513l-7.898-8.787a1.667 1.667 0 01.891-2.744l11.555-2.466a1.667 1.667 0 001.095-.795l5.915-10.227a1.667 1.667 0 012.886 0l5.915 10.227c.236.408.634.697 1.095.795l11.555 2.466a1.667 1.667 0 01.891 2.744l-7.898 8.787c-.315.35-.467.818-.418 1.287l1.214 11.648a1.667 1.667 0 01-2.38 1.675l-10.695-5.144a1.667 1.667 0 00-1.444 0l-10.695 5.144zm8.96-8.749a5.667 5.667 0 014.913 0l6.93 3.333-.782-7.492a5.667 5.667 0 011.422-4.376l5.202-5.787-7.61-1.624a5.666 5.666 0 01-3.722-2.704L24 9.989l-3.896 6.735a5.666 5.666 0 01-3.722 2.704l-7.61 1.624 5.202 5.787a5.667 5.667 0 011.422 4.376l-.782 7.492 6.93-3.333z"/></svg>
</template>
<script>

export default {
  name: 'IconStar',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
